<template>
    <button style="border: none; width: 78px; height: 16px;" :class="buttonClass" @click="collapsSearchPanel"></button>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const props = defineProps({
  tabName: {
    type: String,
    default: () => ""
  }
});

const currentState = ref(1);

const buttonClass = computed(() => {
    switch(currentState.value) {
        case 1: return 'btnSearchview--collapse'
        case 2: return 'btnSearchview--expand';
        default: return 'btnSearchview'
    }
})

const collapsSearchPanel = () => {
    let formPanel = document.querySelector(`main[tabname='${props.tabName}'] section[class='search-conts']`);

    if(currentState.value == 1) {
        currentState.value = 2;
        formPanel?.setAttribute("style", "display:none")
    }
    else {
        currentState.value = 1;
        formPanel?.setAttribute("style", "")
    }
}
</script>